import React, { Component } from "react";
import {
  setAttrFilter,
  clearAttrFilter,
} from "../../redux/actions/shopActions";
import {
  addToCart
} from "../../redux/actions/cartActions";
import {
  showMessageModal,
  showUtilModal
} from "../../redux/actions/miscActions";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom'
import { Menu, Dropdown } from "antd";


export class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceFilter: "lowtohigh",
      pageStart: 0,
      itemsPerPage: 12,
      currentPage: 1,
    };
  }

  handleTagSelect = (tag) => {
    this.props.setAttrFilter(tag);
  };

  componentDidMount=()=>{
    this.setState({
      showLoader: false
    })
  }

  handlePriceFilterSelect = (e) => {
    const { key } = e;
    if (key === "lowtohigh") {
      this.setState({
        priceFilter: "lowtohigh",
      });
    } else {
      this.setState({
        priceFilter: "hightolow",
      });
    }
  };

  componentDidUpdate=(prevProps)=>{
    if(prevProps.shop.filters !== this.props.shop.filters || prevProps.shop.subFilters !== this.props.shop.subFilters){
      this.setState({pageStart: 0,
        itemsPerPage: 12,
        currentPage: 1,})
    }
   
    if(prevProps.shop.searchValue !== this.props.shop.searchValue){
      this.setState({pageStart: 0,
        itemsPerPage: 12,
        currentPage: 1,})
    }
  }

  
  handleNextPage=()=>{
    window.scrollTo({top: 0 , behavior: 'smooth' } )     
    this.setState({
      pageStart: this.state.itemsPerPage,
      itemsPerPage: this.state.itemsPerPage + 12,
      currentPage: this.state.currentPage + 1
    })
  }

  handlePrevPage=()=>{
    if(this.state.pageStart !== 0){
      window.scrollTo({top: 0 , behavior: 'smooth' } )   
      this.setState({
        pageStart: this.state.pageStart - 12,
        itemsPerPage: this.state.itemsPerPage - 12,
        currentPage: this.state.currentPage - 1
      })
    }
  }

  handlePagination=(num)=>{
    window.scrollTo({top: 0, behavior: 'smooth' } )   
    this.setState({
      pageStart: num * 12,
      itemsPerPage: num * 12 + 12,
      currentPage: num + 1
    })
  }

  handleAddToCart=(product)=>{
    const { user, isAuthenticated } = this.props.user
    const { hasProfile } = this.props.profile    
    const btn = <div>winkelwagen <i className="fas fa-angle-right"></i></div>
    if(isAuthenticated && hasProfile){
      this.props.addToCart(product.id, 1, user.uid, product.productNaam, btn, this.props.history)
    } else if ( isAuthenticated && !hasProfile){
      const feedback = {
        type: 'warning',
        txt: 'voltooi uw profiel om door te gaan'
      }
      this.props.showMessageModal(feedback)
      this.props.history.push('/user')
    } else if (!isAuthenticated){
      this.props.showUtilModal('login')
    }
  }

  render() {
    const { pageStart, itemsPerPage, currentPage, priceFilter } = this.state;
    const { products } = this.props.products;
    const { filters, subFilters, searchValue } = this.props.shop;
   
    const priceFilterMenu = (
      <Menu onClick={this.handlePriceFilterSelect}>
        <Menu.Item key="lowtohigh">
          <span>Low to high</span>
        </Menu.Item>
        <Menu.Item key="hightolow">
          <span>High to low</span>
        </Menu.Item>
      </Menu>
    );

    const setPriceFilter =
    priceFilter === "lowtohigh"
      ? (a, b) =>
          a ? a.productPrijs - b.productPrijs : null
      : (a, b) =>
          b ? b.productPrijs - a.productPrijs : null;

    const filteredCategories = products.filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).filter(x => x.productCategorie.includes(filters.toString().split(",").join(" ").toLowerCase())).filter(x => x.productAttributen.toString().toLowerCase().includes(subFilters.toString().split(",").join(" ").toLowerCase()))

    const searchResults = products
      .filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase()))
      .sort((a, b) =>
        a.productNaam > b.productNaam
          ? 1
          : b.productNaam > a.productNaam
          ? -1
          : 0
      )
      .filter(x => x.productCategorie.includes(filters.toString().split(",").join(" ").toLowerCase())).sort(setPriceFilter)
      .filter(x => x.productAttributen.toString().toLowerCase().includes(subFilters.toString().split(",").join(" ").toLowerCase()))

    const productCards = searchResults.slice(pageStart, itemsPerPage).map((x, index) => {
      return (
        <div className="product-card" key={x.id}>

          <div className={`product-image ${x.productOnSale ? 'on-sale' : ''}`}>
          {x.productOnSale ? <span className="on-sale-tag">SALE</span> : null}
            <img src={x.productImage} alt="" />
          </div>

          <div className="product-name">
            <p>{x.productNaam}</p>
          </div>

          <div className="product-attr">
            <p>{x.productAttributen.toString().split(",").join(" - ")}</p>
          </div>

          <div className="product-description">
            <p>{x.productOmschrijving.slice(0, 65)}</p>
          </div>

          <div className="product-price">
            <div>
              <p>
                prijs per {x.productEenheid}{" "}
              </p>
      <p className={`${x.productOnSale ? 'sales-price' : ''}`}><span>{new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(x.productPrijs)}`)}</span> {x.productOnSale ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(x.salesPrice)}`) : null}</p>
            </div>
            <button onClick={()=>this.handleAddToCart(x)}>
              Toevoegen
            </button>
          </div>
          
        </div>
      );
    });

    var i;
    var numberOfPages = [];    
    for(i=1; i <= Math.ceil(filteredCategories.length/12); i++){
      numberOfPages.push(i) 
    }    
    const pagesButton = numberOfPages.map((x, index) => { return(
      <li key={index} className={currentPage === index + 1 ? 'active-page' : ''} onClick={()=>this.handlePagination(index)}>{index + 1}</li>
      )})

    return (
      <div>
          <div className="price-filter">
          <Dropdown overlay={priceFilterMenu} trigger={["click"]}>
                {priceFilter === 'lowtohigh' ? <p><i className="fas fa-filter"></i> Low to high <i className="fas fa-caret-down"></i></p> : <p><i className="fas fa-filter"></i> High to low <i className="fas fa-caret-down"></i></p>}
              
              </Dropdown>
            
          </div>
        <div className="product-cards-list">
          {products && products.length > 0 && productCards.length > 0 ? productCards : 
          <div className="not-found">
            <p>Geen resultaten gevonden</p>
          </div> 
            }
            <div className="products-page-pagination">
                 {filteredCategories.length > 0 ? <ul>
                    <li onClick={this.handlePrevPage} className={`prev-page-button ${currentPage === 1 ? 'disable-prev-page' : ''}`}><i className="fas fa-chevron-left"></i></li>
                    {pagesButton}
                    <li onClick={this.handleNextPage} className={`next-page-button ${itemsPerPage >= filteredCategories.length ? 'disable-next-page' : ''}`}><i className="fas fa-chevron-right"></i></li>
                  </ul> : null}
                </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  shop: state.shop,
  user: state.user,
  profile: state.profile
});

export default connect(mapStateToProps, { setAttrFilter, clearAttrFilter, addToCart, showMessageModal, showUtilModal })(
  withRouter(Products)
);
